const models = [
  {
    name: 'Claude 3.5 Sonnet',
    provider: 'Anthropic',
    description: 'Latest and most capable model, perfect for complex tasks',
    price: '$3',
    discountedPrice: '$0.9',
  },
  {
    name: 'GPT-4o',
    provider: 'OpenAI',
    description: 'Excellent for analysis and long-form content generation',
    price: '$2.50',
    discountedPrice: '$0.75',
  },
  {
    name: 'GPT-4o-mini',
    provider: 'OpenAI',
    description: 'Cost-effective model for general-purpose tasks',
    price: '$0.150',
    discountedPrice: '$0.045',
  },
  {
    name: 'Gemini 2.0 Flash Experimental',
    provider: 'Google',
    description: 'Advanced model with strong reasoning capabilities',
    price: '$0.016',
    discountedPrice: '$0.0048',
  },
];

export default function TrendingModels() {
  return (
    <div className="py-24" id="models">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Popular Models
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Access the best language models through our unified API
          </p>
        </div>
        <div className="mt-20 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {models.map((model) => (
            <div
              key={model.name}
              className="rounded-2xl border border-gray-200 p-8 flex flex-col justify-between h-full"
            >
              <div>
                <h3 className="text-xl font-bold text-gray-900 truncate">{model.name}</h3>
                <p className="mt-1 text-sm text-gray-600">{model.provider}</p>
                <p className="mt-4 text-gray-600 line-clamp-3">{model.description}</p>
              </div>
              <div className="mt-6">
                <div>
                  <span className="text-3xl font-bold text-gray-900">{model.discountedPrice}</span>
                  <span className="text-gray-600">/1M tokens</span>
                </div>
                <div className="mt-1 text-sm">
                  <span className="line-through text-gray-500">{model.price}</span>
                  <span className="line-through ml-2 text-green-600">Save 20%</span>
                  <span className="ml-2 text-red-600">Save 70%</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}